/**
 * Módulo: Split Slider
 * Swiper de slides em duas colunas (conteúdo + imagem). Ativo em todos os
 * breakpoints; navegação por setas únicas que param nas extremidades.
 */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initSplitSlider() {
  document.querySelectorAll('.split-slider__swiper').forEach(el => {
    if (el.swiper) return;

    const wrapper = el.closest('.split-slider');
    if (!wrapper) return;

    const prevEl = wrapper.querySelector('.split-slider__btn--prev');
    const nextEl = wrapper.querySelector('.split-slider__btn--next');

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        prevEl,
        nextEl,
      },
      a11y: {
        prevSlideMessage: 'Slide anterior',
        nextSlideMessage: 'Próximo slide',
      },
    });
  });
}
